import api from './api';

export const getRouteByRouteCode = (routeCode: string) => {
  return api.get({
    path: `/routes/${routeCode}`,
  });
};
